module.exports = __webpack_public_path__ + "img/user_sbw.c52fcb5d.png";